/**
 * Collection Grid Layout Fix
 * 
 * This script ensures consistent heights and layouts for product items in collection grids.
 * It adjusts product item heights to match the tallest item in each row, improving the visual appearance.
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a collection page
    if (document.querySelector('.collection-template') || document.querySelector('.product-grid-view')) {
      // Initialize the fix
      initProductGridFix();
      
      // Re-apply the fix on window resize
      window.addEventListener('resize', debounce(initProductGridFix, 200));
    }
  });
  
  /**
   * Initialize the product grid layout fix
   */
  function initProductGridFix() {
    // Reset all heights first to ensure accurate measurements
    resetProductHeights();
    
    // Equalize heights for product cards within the same row
    equalizeProductHeights();
    
    // Ensure price alignments are consistent
    alignProductPrices();
  }
  
  /**
   * Reset product item heights to their natural state
   */
  function resetProductHeights() {
    const productItems = document.querySelectorAll('.product-item-v1');
    const productTitles = document.querySelectorAll('.product-item-v1 .title-product');
    const productInfos = document.querySelectorAll('.product-item-v1 .info-product');
    
    // Reset product items
    productItems.forEach(item => {
      item.style.height = '';
    });
    
    // Reset product titles
    productTitles.forEach(title => {
      title.style.height = '';
    });
    
    // Reset product info sections
    productInfos.forEach(info => {
      info.style.height = '';
    });
  }
  
  /**
   * Equalize heights for product items in the same row
   */
  function equalizeProductHeights() {
    // Get all product rows
    const productRows = getProductRows();
    
    // Process each row
    productRows.forEach(row => {
      const rowItems = Array.from(row);
      
      // Skip if only one item in row
      if (rowItems.length <= 1) return;
      
      // Find the max heights in this row
      const maxItemHeight = getMaxHeight(rowItems);
      const maxTitleHeight = getMaxHeight(rowItems.map(item => item.querySelector('.title-product')));
      const maxInfoHeight = getMaxHeight(rowItems.map(item => item.querySelector('.info-product')));
      
      // Apply max heights to all items in this row
      rowItems.forEach(item => {
        if (maxItemHeight > 0) item.style.height = `${maxItemHeight}px`;
        
        const titleEl = item.querySelector('.title-product');
        if (titleEl && maxTitleHeight > 0) titleEl.style.height = `${maxTitleHeight}px`;
        
        const infoEl = item.querySelector('.info-product');
        if (infoEl && maxInfoHeight > 0) infoEl.style.height = `${maxInfoHeight}px`;
      });
    });
  }
  
  /**
   * Ensure price elements are consistently aligned
   */
  function alignProductPrices() {
    const priceElements = document.querySelectorAll('.product-item-v1 .price-product');
    
    priceElements.forEach(price => {
      // Ensure price is at the bottom of info section
      const infoSection = price.closest('.info-product');
      if (infoSection) {
        price.style.marginTop = 'auto';
      }
    });
  }
  
  /**
   * Get product items grouped by rows based on their position
   * @returns {Array} Array of product rows
   */
  function getProductRows() {
    const productItems = document.querySelectorAll('.product-item-v1');
    const rows = [];
    let lastTop = -1;
    let currentRow = [];
    
    // Group items by their vertical position (top offset)
    Array.from(productItems).forEach(item => {
      const rect = item.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      
      // If this item is on a new row (different top position)
      if (lastTop !== -1 && Math.abs(top - lastTop) > 5) {
        rows.push(currentRow);
        currentRow = [item];
      } else {
        currentRow.push(item);
      }
      
      lastTop = top;
    });
    
    // Add the last row
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }
    
    return rows;
  }
  
  /**
   * Get the maximum height from a collection of elements
   * @param {Array} elements - Array of DOM elements
   * @returns {number} Maximum height
   */
  function getMaxHeight(elements) {
    let maxHeight = 0;
    
    elements.forEach(el => {
      if (!el) return;
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    return maxHeight;
  }
  
  /**
   * Debounce function to limit function calls
   * @param {Function} func - Function to debounce
   * @param {number} wait - Wait time in milliseconds
   * @returns {Function} Debounced function
   */
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }
})(); 